export const chipBase = {
    display: 'inline-flex',
    alignItems: 'center',
    height: 20,
    borderRadius: 100,
    padding: '2px 8px',
    fontSize: 11,
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: 0.16,
    whiteSpace: 'nowrap',
    flexShrink: 0,
};
